// Module
var code = `{{#listItems}}
<article class="deck-card">
  <p class="deck-card-label"><span class="deck-card-kicker">{{cardKicker}}</span> <span class="deck-card-label-text">{{cardLabel}}</span></p>
  {{#artImage}}
  <img class="deck-card-art" src="{{attrImageSrc}}" alt="" />
  {{/artImage}}
  {{#artPlaceholder}}
  <div class="deck-placeholder">
    <span class="deck-placeholder-label">{{fileName}}</span>
  </div>
  {{/artPlaceholder}}
  {{#statText}}
  <div class="deck-stat">
    <p class="deck-stat-lead">{{lead}}</p>
    <p class="deck-stat-detail">{{detail}}</p>
  </div>
  {{/statText}}
  <p class="deck-card-copy">{{copy}}</p>
  <p class="deck-card-footer"><a class="deck-link" href="{{attrFooterHref}}" target="_blank" rel="noopener noreferrer">{{footerLink}}</a></p>
</article>
{{/listItems}}
`;
// Exports
module.exports = code;